"use client";
import config from "@web/data/config.json";
import { useCallback, useEffect, useSyncExternalStore } from "react";
import { clearError, errorStore, pushError } from "./auth";
import { EventSourceEndpoints, Sports } from "./data";

const wsProtocol = config.COVERAGE.PROTOCOL === "https" ? "wss" : "ws";

export function useEventSource<T>(
  sport: Sports,
  endpoint: EventSourceEndpoints,
  cb: (value: T) => void,
): void {
  const callback = useCallback(
    (ev: MessageEvent<string>) => cb(JSON.parse(ev.data)),
    [cb],
  );
  useEffect(() => {
    if (sport !== "sport-detect") {
      console.warn(
        `Cannot display data for sport '${sport}' because it's restricted.`,
      );
    }
    const es = new WebSocket(
      `${wsProtocol}://${sport}.${config.COVERAGE.DOMAIN}/live/${endpoint}`,
      ["updates"],
    );
    es.addEventListener("message", callback);
    return () => {
      es.removeEventListener("message", callback);
      es.close();
    };
  }, [config, sport, endpoint, callback]);
}

export function useRequestErrors() {
  const errors = useSyncExternalStore(
    errorStore.subscribe,
    errorStore.getSnapshot,
    errorStore.getServerSnapshot,
  );
  return {
    errors,
    clear: clearError,
    push: pushError,
  };
}
